import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry, patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { Knowbe4CampaignStatus } from '../../lib/constants';
import { Knowbe4Service } from '../../service';

export type ListTrainingCampaignsConfig = typeof ListTrainingCampaignsConfig._.Config;

export const ListTrainingCampaignsConfig = IntegrationConfig.make({
  service: Knowbe4Service,
  name: Integration_Handler_Names_Enum.ListTrainingCampaigns,
  configSchema: z.object({
    campaignNamePatternFilter: patternFilterSchema.optional(),
    statusFilter: z
      .array(
        z.enum(Knowbe4CampaignStatus).register(integrationSchemaRegistry, {
          i18n: 'integrations.knowbe4.services.knowbe4.shared.knowbe4_campaign_status',
        }),
      )
      .optional(),
  }),
});
